<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
                ><label>รหัสสินค้า</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="form.sku"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
            ><label>ชื่อสินค้า</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="form.name"
                    disabled/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right"><label>จำนวน</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="text"
                    v-model="form.quantity"
                    disabled/></b-col>
        </b-row>
        <br>
        <b-row sm="11">
            <b-col sm="4" class="col text-right"><label>จำนวนที่ออกจากคลัง</label></b-col>
            <b-col sm="6"><input
                    class="form-control"
                    type="number"
                    v-model="quantity"/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right"><label>หมายเหตุ</label></b-col>
            <b-col sm="6">
                <textarea class="form-control" v-model="reason"></textarea>
            </b-col>
        </b-row>
        <br />
        <b-row>
            <div class="col text-center">
                <button
                        :disabled="form.onSave"
                    type="button"
                    class="btn btn-success"
                    @click="onSubmitExport">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp&nbsp
                <button type="button" class="btn btn-outline-secondary"
                        @click="goToProductExport">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
        <!--<pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import FormTextarea from "bootstrap-vue/src/components/form-textarea/form-textarea";

export default {
    name: "export-data",
    components: { Multiselect, FormTextarea },
    data() {
        return {
            quantity: "",
            reason : "",
        };
    },
    computed: {
        ...mapState({
            form: state => {
                return state.Products.ProductForm;
            },
            user: state => {
                return state.Auth.user;
            }
        }),
    },
    methods: {
        onSubmitExport() {
            if(this.quantity < 0){
                alert('กรุณาใส่จำนวนให้ถูกต้อง');
                this.quantity = 0;
            }
            else{
                if(!this.quantity){
                    this.quantity = 0
                }
                let data = {
                    product_id : this.form.id,
                    quantity: this.quantity,
                    reason: this.reason,
                    product_type_id : this.form.product_type.id,
                    user_id: this.user.id
                };
                if (this.form.quantity < data.quantity) {
                    alert(
                        "ไม่สามารถนำสินค้าออกได้เนื่องจาก จำนวนสินค้าไม่เพียงพอต่อความต้องการ"
                    );
                } else {
                    this.form.onSave = true;
                    this.$emit("submit", data);
                    this.quantity ="";
                    this.reason = "";
                }
            }
        },
        goToProductExport(){
            this.$emit("submit", 1);
            this.quantity = "";
            this.reason = "";
        }

    }
};
</script>

<style scoped></style>
